
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';

import Report from "./Report.vue";
import DateRangePicker from './DateRangePicker.vue';
import Spinner from '@/components/utils/Spinner.vue'
import { dateRangeInfoType } from '@/types/Common';

@Component({
    components:{
        Report,
        DateRangePicker,
        Spinner
    }
})
export default class Statistics extends Vue {

    dataLoaded = false;    
    error = '';
    updated = 0;

    printReady = false;
    updateReport = 0;
    reportDateRange: dateRangeInfoType = {startDate:'', endDate:''};

    results;
    searching = false;
    displayTopUser = false; 

    mounted() {  
        this.displayTopUser = false; 
        this.searching = false;
        this.dataLoaded = false;         
    }

    get viewStatus() {
        if(this.displayTopUser) return 'Display Top User';else return 'Hide Top User'
    }

    public find(){   
        this.error = '';
        this.dataLoaded = false;
        this.searching = true;

        const start = this.reportDateRange.startDate? this.reportDateRange.startDate?.slice(0,10) : null
        const end = this.reportDateRange.endDate? this.reportDateRange.endDate?.slice(0,10) : null
        const url = '/statistics/?start_date='+start+
                    '&end_date='+end+
                    '&tz='+moment().utcOffset();
        
        this.$http.get(url)
        .then((response) => {            
            if(response?.data){
                this.results = response.data;
                this.dataLoaded = true;                    
            }
            this.searching = false;
            
        },(err) => {
            this.searching = false;
            this.error = err.response.data           
        });  
        
    }

    public addReportDateRanges(dateRange){
        this.reportDateRange = dateRange
        this.dataLoaded = false;
        this.updateReport++;
    }

    public onPrintSave() { 
        
        const el= document.getElementById("print");
        const time = moment().format("MMM DD YYYY HH:mm")

        const bottomLeftText = `"COURT OF APPEAL FOR BRITISH COLUMBIA  Printed on `+time+`"`;
        const bottomRightText = `" "`;        
        
        const url = '/statistics/'+'/?name=statistics_report' 
        const margin = '1.2in 0.7in 0.9in 0.7in'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText, '', '', margin);

        const body = {
            'html':pdfhtml,            
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {                       
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = "StatisticsReport.pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000); 
        },err => {
            console.error(err);        
        });
    }
      
   
    


}
